import React__default, { useState } from 'react';
import { AutoshipmentLogoLockup, Anchor, P1 } from '@zooplus/ui-components';
import { useTranslation } from '../../../hooks/use-translations.js';
import { InfoModal } from '../info-modal/InfoModal.js';
import styles from './Title.module.scss.js';
import '../../../node_modules/@zooplus/commons-lang/dist/es/gen/lang.js';
import { useSiteContext } from '../../../node_modules/@zooplus/commons-lang/dist/es/components/SiteProvider.js';
import '../../../node_modules/@zooplus/commons-lang/dist/es/hooks/use-translation.js';

const Title = (props) => {
    const { site, locale } = useSiteContext();
    const { t } = useTranslation(site.realm);
    const [showModal, setShowModal] = useState(false);
    const openModal = () => {
        setShowModal(true);
    };
    return (React__default.createElement("div", { className: `${styles.wrapper} ${props.className}`, "data-testid": "title" },
        React__default.createElement(AutoshipmentLogoLockup, { size: 'medium', locale: locale, realm: site.realm, className: styles.logo }),
        React__default.createElement(Anchor, { isBold: true, onClick: openModal, className: styles.link }, t('checkout.common.learn-more')),
        !props.minifiedLearnMore && (React__default.createElement(P1, { className: styles.text }, t('checkout.header.main-sentence'))),
        React__default.createElement(InfoModal, { isOpen: showModal, setIsOpen: setShowModal })));
};

export { Title };
//# sourceMappingURL=Title.js.map
